package pl.decks.personal.pages.ievp.sections.pitch

enum class PersonalIntroState {
    FOLDED, DISAPPEARING, UNFOLDING, UNFOLDED;

    fun next() = when (this) {
        FOLDED -> DISAPPEARING
        DISAPPEARING -> UNFOLDING
        UNFOLDING -> UNFOLDED
        UNFOLDED -> UNFOLDED
    }
}